import styled, { css } from 'styled-components';
export const UnstyledButton = styled.button `
  position: relative;
  border: none;
  cursor: pointer;
  background: none;
  padding: 0;
  margin: 0;
`;
export const Button = styled.button `
  position: relative;
  font-family: ${({ theme }) => theme.fontFamilyHeading};
  font-size: 16px;
  background-color: ${({ theme }) => theme.buttonPrimaryColor};
  color: ${({ theme }) => theme.buttonPrimaryTextColor};
  border: 2px solid ${({ theme }) => theme.buttonPrimaryColor};

  padding: 0 28px;
  height: 44px;
  text-align: center;
  transition: 0.25s ease-out;
  cursor: pointer;

  &:active,
  &:hover {
    background-color: ${({ theme }) => theme.buttonPrimaryColorHover};
    border: 2px solid ${({ theme }) => theme.buttonPrimaryColorHover};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.buttonPrimaryDisabledColor};
    border: 2px solid ${({ theme }) => theme.buttonPrimaryDisabledColor};
    pointer-events: none;
  }

  ${({ isSecondary }) => isSecondary &&
    css `
      color: ${({ theme }) => theme.buttonSecondaryTextColor};
      background-color: ${({ theme }) => theme.buttonSecondaryColor};
      border: ${({ theme }) => theme.buttonSecondaryBorder};

      &:active,
      &:hover {
        background-color: ${({ theme }) => theme.buttonSecondaryColorHover};
      }

      &:disabled {
        background-color: ${({ theme }) => theme.buttonSecondaryDisabledColor};
        border: ${({ theme }) => theme.buttonSecondaryDisabledBorder};
      }
    `}
`;
